import {
  Dialog,
  styled,
  Button,
  DialogContent,
  FormControl,
  Stack,
  Typography,
  DialogTitle,
  IconButton,
  Grid,
  Avatar,
  Divider,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Utils from "../../core/Utils";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import PropaneIcon from "@mui/icons-material/Propane";
import EvStationIcon from "@mui/icons-material/EvStation";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const SelectVehicleComponent = ({
  open,
  close,
  SelectedCustomer,
  CustomerVehicleDetails,
  AddNewVehicleClick,
  setSelectedVehilce,
  isFromCustomerUsernameSelect,
  backCustomerSelect,
}) => {
  return (
    <BootstrapDialog
      onClose={close}
      aria-labelledby="customized-dialog-title"
      className="cs-modal-sec"
      open={open}
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={close}>
        <Stack direction="row" spacing={2}>
        {isFromCustomerUsernameSelect && <Button onClick={backCustomerSelect} className="back-btn">
                            <NavigateBeforeIcon />
                          </Button>}
        <Typography
          level="h3"
          component="h3"
          fontWeight="600"
          fontSize="2rem"
          className="h3"
        >
          Select Vehicles
        </Typography>
        </Stack>
      </BootstrapDialogTitle>
      <DialogContent
        dividers
        className="modal-dialog-content"
        sx={{ backgroundColor: "#f4f4f4" }}
      >
        <Grid container sx={{ padding: "15px" }} className="card white-bg">
          <Stack direction="row" spacing={2}>
            <Grid container style={{ "align-items": "center" }}>
              <Grid
                xs={12}
                md={4}
                style={{ "flex-basis": "auto", "padding-right": "20px" }}
              >
                <Avatar sx={{ width: "84px", height: "84px" }} alt="S" />
              </Grid>
              <Grid xs={12} md={8}>
                <Typography
                  level="h3"
                  component="h3"
                  fontWeight="600"
                  fontSize="2rem"
                  className="h3"
                >
                  {SelectedCustomer.userName}
                </Typography>
                <Stack direction="row" spacing={2} marginTop="10px">
                  <Stack
                    direction="row"
                    className="card"
                    sx={{ padding: "6px 15px", display: "flex" }}
                  >
                    <PhoneOutlinedIcon sx={{ alignSelf: "center" }} /> &nbsp;{" "}
                    <span>{SelectedCustomer.mobileNumber}</span>
                  </Stack>
                  <Stack
                    direction="row"
                    className="card"
                    sx={{ padding: "6px 15px", display: "flex" }}
                  >
                    <MailOutlinedIcon sx={{ alignSelf: "center" }} /> &nbsp;{" "}
                    <span>{SelectedCustomer.emailId}</span>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </Grid>

        <Grid
          container
          rowSpacing={2}
          sx={{ mt: 1, padding: "0 15px 15px" }}
          className="card white-bg"
        >
          <Grid item xs={12}>
            <Stack
              direction="row"
              spacing={2}
              className="justify-content-between"
              alignItems="center"
            >
              <Typography
                level="h2"
                component="h2"
                fontWeight="600"
                fontSize="2rem"
                className="title-lbl"
              >
                {`Vehicle Details - ${CustomerVehicleDetails.length}`}
              </Typography>
            </Stack>
          </Grid>
          <Divider />
          <Grid container xs={12} className="mt-1 font-size-12">
            {!Utils.IsNullOrEmptyArray(CustomerVehicleDetails) &&
              CustomerVehicleDetails.map((vehicle) => {
                return (
                  <Grid xs={12} md={6} lg={6} className="mb-1" onClick={() => setSelectedVehilce(vehicle)}>
                   {vehicle.number && <Stack
                      className="card mr-1 m-xs-0"
                      padding="10px"
                      style={{ height: "100%" }}
                      direction="row"
                    >
                      <Stack>
                        <h3 className="mt-0">
                          <strong className="input-label" fontWeight="600">
                            {vehicle.number}
                          </strong>
                        </h3>
                        <span className="input-label">{vehicle.make}</span>
                        <span className="input-label">{vehicle.model}</span>
                        {vehicle.color && (
                          <span className="input-label">
                            {vehicle.color}
                            <DirectionsCarIcon
                              style={{
                                color: vehicle.color,
                                "vertical-align": "middle",
                              }}
                            />
                          </span>
                        )}
                        <span>
                          {vehicle.fuelType} &nbsp;
                          {vehicle.fuelType == "Petrol" && (
                            <WaterDropIcon
                              style={{
                                color: "gold",
                                "vertical-align": "middle",
                              }}
                            />
                          )}
                          {vehicle.fuelType == "Diesel" && (
                            <WaterDropIcon
                              style={{
                                color: "#cddc39",
                                "vertical-align": "middle",
                              }}
                            />
                          )}
                          {vehicle.fuelType == "CNG" && (
                            <PropaneIcon
                              style={{
                                color: "#03a9f4",
                                "vertical-align": "middle",
                              }}
                            />
                          )}
                          {vehicle.fuelType == "LPG" && (
                            <LocalGasStationIcon
                              style={{
                                color: "red",
                                "vertical-align": "middle",
                              }}
                            />
                          )}
                          {vehicle.fuelType == "Electric" && (
                            <EvStationIcon
                              style={{
                                color: "green",
                                "vertical-align": "middle",
                              }}
                            />
                          )}
                        </span>
                      </Stack>
                    </Stack>}
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{ padding: "15px", display: "flex", justifyContent: "space-between" }}
      >
        <FormControl>
          <Button
            type="submit"
            variant="contained"
            className="btn btn-primary"
            onClick={AddNewVehicleClick}
          >
            Add New Vehicle
          </Button>
        </FormControl>
        <FormControl>
          <Button
            type="submit"
            variant="contained"
            className="btn btn-secondary"
            onClick={close}
          >
            Cancel
          </Button>
        </FormControl>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default SelectVehicleComponent;
